import React from 'react';
import  ReactDOM  from 'react-dom';

import App from './App'; 
import './index.css';

import * as serviceWorker from "./serviceWorker";

// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import { Footer, Blog } from "./containers";
// import ArtiTicket  from "./projects/ArtiTicket";
// import  BOTW  from "./projects/BOTWicons";
// import DarkStar from "./projects/DarkStar";
// import Minus from './projects/Minus';
// import Lettie from './projects/Lettie';
// import Infinitea from './projects/Infinitea';
// import RevoltWear from './projects/RevoltWear';
// import SRDIllustrations from './projects/SRDIllustrations';
// import SRDsocial from './projects/SRDsocial';
import Redirect from './Redirect';
import RedirectWork from './RedirectWork';



import AboutMe from "./pages/AboutMe";
import Illustrations from "./pages/GD";

// import ScrollToTop from './components/ScrollToTop';



ReactDOM.render(
    <Router>
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<Redirect />} />
         <Route path="/work" element={<RedirectWork />} />
        

         {/* <Route path="/" element={<App />} /> */}
         
        {/* <Route path="#ux-ui" element={<Blog />}/>  */}
        {/* below: DONT USE THESE USUALLY */}
          {/* <Route path="" element={<Posts />} /> */}
          {/* <Route path=":postSlug" element={<Post />} /> */}
        {/* </Route>     */}
       
        {/* <Route path="/Breath-of-the-Wild-icons" element={<BOTW />} />
        <Route path="/Dark-Star" element={<DarkStar />} />
        <Route path="/Artiticket" element={<ArtiTicket />} />
        <Route path="/Avatars-Emojis" element={<SRDIllustrations />} />
        <Route path="/Spatial-Social" element={<SRDsocial />} />
        <Route path="/Lettie-and-Co" element={<Lettie />} />

        
        <Route path="/Minus-The" element={<Minus />} />
        <Route path="/Infinitea" element={<Infinitea />} />
        <Route path="/RevoltWear" element={<RevoltWear />} />

     
        <Route path="/about" element={<AboutMe />} />
        <Route path="/illustrations" element={<Illustrations />} /> */}
        

      </Routes>
      {/* <Footer /> */}
    </Router>,
  
    document.getElementById("root")
  );
  
  serviceWorker.unregister();
// ReactDOM.render(<App />, document.getElementById('root'));

